<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: $t('togetherai.buy_package') }"
    hide-confirm
    hide-overlay
    max-width="500"
    transition="dialog-bottom-transition"
    @close="discountField = { show: false, model: '' }"
  >
    <div key="prices" class="pa-4">
      <custom-tabs
        v-model="tabs"
        :tab-items="prices"
        :window-items="prices"
        fixed-tabs
      >
        <template v-slot:tab="{ tab }">
          {{ tab.title }}
        </template>

        <template v-slot:item="{ item }">
          <div class="pt-2 red--text">
            {{ $t("togetherai.tax_notice") }}
          </div>

          <v-list-item class="overflow-hidden border pa-2 rounded mt-2">
            <v-list-item-icon class="position-relative align-self-center">
              <div
                class="border border-2 rounded-circle position-absolute p-6"
                style="top: 50%; transform: translateY(-50%); right: -4em"
              >
                <v-icon size="70">mdi-plus-box</v-icon>
              </div>
            </v-list-item-icon>

            <v-list-item-content class="ms-4">
              <v-list-item-title>
                <h3 v-if="!!item.number">
                  <v-icon color="amber">mdi-clock</v-icon>
                  <small>{{ $t("togetherai.package") }}</small>
                  {{ item.number | currency }}
                  <small>{{ $t("togetherai.package") }}</small>
                </h3>

                <h3 class="d-flex align-center">
                  <v-icon color="amber darken-3">mdi-wallet</v-icon>
                  <div class="d-inline-block mr-1">
                    <span
                      :class="
                        !!item.discount && !!Number(item.discount)
                          ? 'text-decoration-line-through grey--text d-inline-block mb-1'
                          : ''
                      "
                    >
                      {{ item.price | currency }}
                      <v-chip
                        v-if="!!item.discount && !!Number(item.discount)"
                        class="mr-2"
                        color="red"
                        dark
                        small
                      >
                        {{ item.discount }} %
                      </v-chip>
                    </span>
                    <template v-if="!!item.discount && !!Number(item.discount)">
                      <br />
                      {{ item | getDiscount | currency }}
                    </template>
                    <small>{{ $t("togetherai.rial") }}</small>
                  </div>
                </h3>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action class="d-flex flex-column">
              <v-btn
                :disabled="discountField.show"
                :loading="loading"
                color="green lighten-2"
                @click="upgradeQr(item.id)"
              >
                {{ $t("togetherai.buy_button") }}
              </v-btn>
              <v-btn
                :loading="loading"
                class="mt-2 mx-auto"
                color="primary"
                outlined
                small
                @click="
                  [
                    (discountField.show = !discountField.show),
                    (priceId = item.id),
                  ]
                "
              >
                {{ $t("togetherai.discount_label") }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </custom-tabs>
    </div>

    <v-expand-transition>
      <div v-if="discountField.show" key="discount">
        <v-card-title>{{ $t("togetherai.discount_label") }}؟</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="discountField.model"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            :label="$t('togetherai.discount_label')"
            outlined
            prepend-inner-icon="mdi-percent-box"
          >
            <template v-slot:append-outer>
              <v-btn
                :loading="loading"
                class="mt-n1"
                color="green lighten-2"
                dark
                depressed
                @click="upgradeQr(priceId)"
              >
                {{ $t("togetherai.submit_discount") }}
              </v-btn>
            </template>
          </v-text-field>
        </v-card-text>
      </div>
    </v-expand-transition>
  </custom-popup>
</template>

<script>
import axios from "axios";

export default {
  name: "togetherAiUpgradeNew",

  props: {
    value: Boolean,
    currentPackage: Object,
  },

  data: () => ({
    tabs: null,
    discountField: {
      show: false,
      model: "",
    },
    prices: [],
    loading: false,
    priceId: null,
  }),

  mounted() {
    this.getPackages();
    this.getPackage();
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedCurrent: {
      get() {
        return this.currentPackage;
      },
      set(val) {
        this.$emit("update:currentPackage", val);
      },
    },
  },

  filters: {
    getDiscount(price) {
      let p = Math.floor((Number(price.discount) * price.price) / 100);
      return price.price - p;
    },
  },

  methods: {
    header() {
      let token = localStorage.getItem("id_token");
      return {
        Authorization: token ? `Bearer ${token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    getPackage() {
      axios
        .get(this.$aiApi + "/packages/user/package", {
          headers: this.header(),
        })
        .then((data) => {
          this.computedCurrent = data.data.data;
        })
        .catch((response) => {
          console.error(response);
        })
        .finally(() => {});
    },
    getPackages() {
      this.loading = true;
      axios
        .get(this.$aiApi + "/packages", {
          headers: this.header(),
        })
        .then(({ data }) => {
          this.prices = data.data;
        })
        .finally(() => (this.loading = false));
    },
    upgradeQr(packageId) {
      this.loading = true;
      axios
        .get(`${this.$aiApi}/packages/buy/${packageId}`, {
          headers: this.header(),
        })
        .then((response) => {
          this.dialog = false;
          this.$modal.success(
            this.$t("togetherai.success_title"),
            this.$t("togetherai.success_message")
          );
          this.getPackage();
        })
        .catch((reason) => {
          console.log(reason);
          if (reason.response.status === 402) {
            this.$modal.error(
              this.$t("togetherai.error_title"),
              this.$t("togetherai.error_insufficient_funds")
            );
          } else {
            this.$modal.error(
              this.$t("togetherai.error_title"),
              this.$t("togetherai.error_upgrade")
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
